import { createAction } from '@reduxjs/toolkit';

import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const cardCancelAutoPayScheduleModalSetIsModalOpen = createAction(
    'CARD_CANCEL_AUTO_PAY_SCHEDULE_MODAL::SET_IS_MODAL_OPEN',
);

const useCardCancelAutoPayScheduleModal = () => {
    const { isModalOpen, setIsModalOpen } = useModal();

    return {
        isModalOpen,
        setIsModalOpen,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useCardCancelAutoPayScheduleModal();

        useActionObservableCallback(
            hookAction$,
            cardCancelAutoPayScheduleModalSetIsModalOpen().type,
            (value) => hook.setIsModalOpen(value),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [
    CardCancelAutoPayScheduleModalProvider,
    useCardCancelAutoPayScheduleModalContext,
] = createContextProvider(providerFactory);
